/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupseatlimitplaceholder3Inputs */

const en_signupseatlimitplaceholder3 = /** @type {(inputs: Signupseatlimitplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited`)
};

const de_signupseatlimitplaceholder3 = /** @type {(inputs: Signupseatlimitplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt`)
};

/**
* | output |
* | --- |
* | "Unlimited" |
*
* @param {Signupseatlimitplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupseatlimitplaceholder3 = /** @type {((inputs?: Signupseatlimitplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupseatlimitplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupseatlimitplaceholder3(inputs)
	return de_signupseatlimitplaceholder3(inputs)
});
export { signupseatlimitplaceholder3 as "signupSeatLimitPlaceholder" }